/**
 * API Utility Functions
 * 
 * Common utility functions for API operations
 */


/**
 * Extract error message from Axios error
 * 
 * Handles various error response formats from the Django backend:
 * - { message: "..." }
 * - { error: "..." }
 * - { detail: "..." }
 * - Array of error strings
 * - Plain string
 * 
 * @param {Error} error - Axios error object
 * @returns {string} Human-readable error message
 */
export function getErrorMessage(error) {
  if (!error.response) {
    return error.message || 'Network error. Please check your connection.';
  }

  const data = error.response.data;

  if (typeof data === 'string') {
    return data;
  }

  if (data?.message) {
    return data.message;
  }

  if (data?.error) {
    return data.error;
  }

  if (data?.detail) {
    return data.detail;
  }

  if (Array.isArray(data) && data.length > 0) {
    return data[0];
  }

  if (typeof data === 'object' && data !== null) {
    const messages = Object.values(data).flat();
    if (messages.length > 0) {
      return messages.join(', ');
    }
  }

  return 'An error occurred. Please try again.';
}
